// Component: Hero
// Author: Susmita
import * as React from 'react';
import HeroNPM from '@component/Hero';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const Hero = (props) => {
  return (
    <>
      <HeroNPM
        title={<Text field={props.fields?.Title} />}
        eventDate={<Text field={props.fields?.EventDate} />}
        location={<Text field={props.fields?.Location} />}
        bannerImageUrl={props.fields?.BannerImage?.value?.src}
        bannerImageAlt={props.fields?.BannerImage?.value?.alt}
        textColor={props.fields?.TextColor?.fields?.Value?.value}
        videourl={props.fields?.VideoUrl?.value}
      />
    </>
  );
};

export default withSitecoreContext()(Hero);
